import(/* webpackMode: "eager" */ "/vercel/path0/src/app/projects/crossx/page.tsx");
